import type { CardKind, TerrainKind } from './types';

export const CARDS: Record<CardKind, { name: string; description: string; timing: string }> = {
  chase: { name: '추격', description: '다음 도~모 이동에 +1칸. 빽도에는 적용되지 않음.', timing: '우리 팀 이동 투표 중' },
  shortcut: { name: '샛길', description: '다음 이동 도중 갈림길에서도 지름길로 진입.', timing: '우리 팀 이동 투표 중' },
  retreat: { name: '후퇴', description: '도~모 결과 하나를 써서 지나온 길로 1칸 후퇴.', timing: '우리 팀 이동 투표 중' },
  smoke: { name: '연막', description: '잡기 이동 취소. 상대는 윷 결과를 소모하고 제자리에 남음.', timing: '상대 잡기 예고 중 · 환경 공격에는 사용 불가' },
  delay: { name: '시간벌기', description: '잡기는 허용하되 이번 잡기의 추가 던지기를 막음.', timing: '상대 잡기 예고 중' },
  breakthrough: { name: '돌파', description: '이번 이동의 연막·시간벌기·긴급탈출을 무효화.', timing: '상대가 방어 카드를 쓴 뒤' },
  push: { name: '밀치기', description: '적 한 무리를 인접한 빈 칸으로 이동. 잡기·완주는 발생하지 않음.', timing: '우리 팀 던지기 또는 이동 투표 중' },
  curse: { name: '물귀신', description: '아군과 적 무리를 연결. 다음 차례부터 아군이 잡히거나 환경에 죽으면 적도 출발 복귀. 2라운드 유지.', timing: '우리 팀 던지기 또는 이동 투표 중' },
  rescue: { name: '긴급탈출', description: '아군 한 무리를 인접한 빈 칸으로 이동.', timing: '우리 팀 차례 또는 상대 잡기 예고 중' },
};
export const CARD_KINDS = Object.keys(CARDS) as CardKind[];
export const TERRAIN: Record<TerrainKind, { name: string; description: string }> = {
  lightning: { name: '낙뢰', description: '표시된 칸의 말이 모두 출발로 돌아갑니다.' },
  collapse: { name: '붕괴', description: '표시된 칸에는 착지할 수 없습니다. 충분한 이동 수로 건너세요.' },
  gale: { name: '질풍', description: '표시된 칸에서 출발하는 도~모 이동은 두 배. 추격 +1은 그 뒤 적용됩니다.' },
};
export const MODE_NAMES = { vanilla: '바닐라', augment: '변칙' } as const;
export function movementLabel(modifier?: string): string {
  const labels: Record<string, string> = { chase: '추격 +1', shortcut: '샛길', retreat: '후퇴 1칸', gale: '질풍 ×2' };
  return modifier?.split('+').map(kind => labels[kind] ?? '').filter(Boolean).join(' · ') ?? '';
}
